import {
  EmployeePledgeLookupsDto,
  OrganizationEmployeeDto,
} from "../app/model/api/types/dto";
import { OrganizationCampaignDto } from "../app/model/api/types/dto/organizationCampaignDto";
import { EmployeePledgeViewModel, EmployeeLoginViewModel } from "../viewModels";
import { FormProps } from "./componentTypes";

enum ContributionOption {
  $1Day = "f45ccdf6-1bb2-4440-207a-08dc5f921fb1",
  $2Day = "c352a78d-200c-4280-207b-08dc5f921fb1",
  $3Day = "fa4d711a-fff8-4f28-207c-08dc5f921fb1",
  $4Day = "43264c88-2e9e-4930-207d-08dc5f921fb1",
  $5Day = "a1cf1c8b-27ef-4f2a-207e-08dc5f921fb1",
  $10Day = "b8ee7835-19be-42dd-207f-08dc5f921fb1",
  Other = "3d059f40-3b51-456d-2080-08dc5f921fb1",
}

enum PaymentOption {
  PayrollDeduction = "9228bfa4-8039-4da6-206d-08dc5f921fb1",
  Check = "e641f54f-a4b8-4f00-206e-08dc5f921fb1",
  CreditCard = "44768491-ef20-44aa-206f-08dc5f921fb1",
}
export interface EmployeePledgeFormProps
  extends FormProps<EmployeePledgeViewModel> {
  lookups?: EmployeePledgeLookupsDto;
  employee?: OrganizationEmployeeDto;
  campaign?: OrganizationCampaignDto;
  pledgeQuery?: any;
}

export interface EmployeePledgeSummaryProps {
  summary: EmployeePledgeViewModel;
  lookups?: EmployeePledgeLookupsDto;
  isPledgeSuccess?: boolean;
  isConfirmation?: boolean;
  onPrintReady?: (print: () => void) => void;
}
export interface EmployeeLoginProps extends FormProps<EmployeeLoginViewModel> {}

export { ContributionOption, PaymentOption };
